import { MAP_TYPES } from '@deck.gl/carto';

const HOUSEHOLDSINNOAAFLOODLOW2070DIFF_SUMTOTALJOBSDIFF_JOBACCESSS45MINUTETRANSITDIFF_SOURCE_ID =
  'householdsInNoaaFloodHigh2070Diff_SumTotalJobsDiff_JobAccess45MinuteTransitDiffSource';

const source = {
  id: HOUSEHOLDSINNOAAFLOODLOW2070DIFF_SUMTOTALJOBSDIFF_JOBACCESSS45MINUTETRANSITDIFF_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.bmpo_curated_dev.BMPO_tileset_01',
};

export default source;
